export default {"src":"/_next/static/media/share_raw.713dbcd1.svg","height":15,"width":18,"blurWidth":0,"blurHeight":0};